<template>
  <!-- MAIN -->
  <section class="section">
    <div class="columns" id="main">
      <div class="column is-2">
        <side-menu class="column" :header="versionsHeader" :items="products" :selectedItemId="productId"
                   v-on:elementClick="toggleVersion"></side-menu>
        <side-menu class="column" :header="groupsHeader" :items="groups" :selectedItemId="groupId"
                   v-on:elementClick="toggleGroup"></side-menu>
      </div>
      <!-- CONTENT -->
      <main class="container column is-8 main">
        <!-- <app-breadcrumb :breadcrumbItems="appBreadcrumbs"></app-breadcrumb> -->
        <content-filter v-on:searchClick="searchHandler" :createNewItem="createChange" :filterGroups="filterGroups"
                        :infoMsg="filterMsg"></content-filter>

        <!-- search results header -->
        <nav v-if="searchingText.length > 0" class="level-left">
          <div class="level-item">
            <p class="subtitle is-4">
              <span>Search results for: {{ searchingText}}</span>
            </p>
          </div>
          <b-tooltip class="level-item" label="Clear search results">
            <button class="delete" v-on:click="clearSearch">Clear</button>
          </b-tooltip>
        </nav>
        <br>

        <div v-for="(version, index) in this.versions"
             :key="index">
          <version-card :version="version" v-on:edit="editChange" v-on:delete="deleteVersionModal" :action1="'edit'" :action2="'delete'"></version-card>
          <br>
        </div>
        <pagination class="is-centered" :urlBuilder="urlBuilder"
                    v-bind:currentPage="page.pageNumber"
                    v-bind:lastPage="page.totalPages" />

        <loading :active.sync="loading"
                 :can-cancel="false"
                 :is-full-page="false"></loading>
      </main>

      <!--END CONTENT -->
      <group-version-creator v-if="isUpdatingGroup" v-on:closeGroupVersionEditor="closeGroupVersionEditor"
                             :groupId="groupId" :header="VersionEditorHeader" />
      <version-editor v-if="isEditorVisible" v-on:closeVersionEditor="closeVersionEditor"
                      :versionId="this.versionId" :productId="productId" :header="VersionEditorHeader" />
      <delete-confirmer v-if="isDeleteModalVisible" :text="deleteMsg" :header="deleteHeader"
                        v-on:close="closeChangeDeleteWindow" :id="this.productId" v-on:delete="deleteVersion" />
    </div>
  </section>
  <!-- END MAIN -->
</template>

<script>
  // import AppHeader from "./components/AppHeader";
  import SideMenu from "../SideMenu";
  import AppBreadcrumb from "../AppBreadcrumb";
  import ContentFilter from "../ContentFilter";
  import VersionCard from "../VersionCard";
  import VersionEditor from "../VersionEditor";
  import GroupVersionCreator from "../GroupVersionCreator"
  import DeleteConfirmer from "../DeleteConfirmer";
  import Pagination from "vue-bulma-pagination/src/Pagination";
  //import this.HTTP from "../Http";

  import Loading from "vue-loading-overlay";
  import "vue-loading-overlay/dist/vue-loading.min.css";

  export default {
    name: "version-view",
    components: {
      SideMenu,
      AppBreadcrumb,
      ContentFilter,
      VersionCard,
      VersionEditor,
      GroupVersionCreator,
      DeleteConfirmer,
      Pagination,
      Loading
    },
    data() {
      return {
        products: [],
        groups: [],
        versions: [],
        versionsHeader: "Products",
        groupsHeader: "Groups",
        isEditorVisible: false,
        isUpdatingGroup: false,
        isDeleteModalVisible: false,
        deleteHeader: "Are you sure that you wanna delete this version?",
        deleteMsg: "This version will be lost forever!",
        productId: -1,
        versionId: -1,
        groupId: -1,
        VersionEditorHeader: "",
        filterGroups: [],
        viewingGroups: false,

        //pagination
        page: {
          pageNumber: 1,
          totalPages: 13,
          pageSize: 10,
          totalItems: -1
        },

        searchingText: "",
        loading: false
      };
    },
    methods: {
      getProducts() {
        return new Promise((resolve, reject) => {
          this.HTTP.get("products/" + 1 + "/" + 100)
            .then(response => {
              resolve(response);
            })
            .catch(e => {
              reject(e);
            });
        });
      },
      getGroups() {
        return new Promise((resolve, reject) => {
          this.HTTP.get("productGroups/" + 1 + '/' + 100)
            .then(response => {
              resolve(response);
            })
            .catch(e => {
              reject(e);
            });
        });
      },
      getVersions() {
        this.loading = true;
        let query = this.viewingGroups ? "ProductVersions/group/" : "ProductVersions/product/";
        query +=
          (this.viewingGroups ? this.groupId : this.productId) + "/" + this.page.pageNumber + "/" + this.page.pageSize;
        if (
          this.searchingText !== null &&
          this.searchingText !== undefined &&
          this.searchingText.length > 0 &&
          !this.viewingGroups
        ) {
          query += "/" + this.searchingText;
        }
        this.HTTP.get(query)
          .then(response => {
            this.versions = response.data.entities;
            this.page = response.data.page;
            this.loading = false;
            console.log(response.data.entities);
          })
          .catch(e => {
            console.log(e);
          });
      },
      toggleVersion(productId) {
        this.productId = productId;
        this.groupId = -1;
        this.page.pageNumber = 1;
        this.searchingText = "";
        this.viewingGroups = false;
      },
      toggleGroup(groupId) {
        this.groupId = groupId;
        this.productId = -1;
        this.page.pageNumber = 1;
        this.searchingText = "";
        this.viewingGroups = true;
      },

      createChange() {
        if (this.viewingGroups) {
          this.isUpdatingGroup = true;
          this.versionId = -1;
          this.VersionEditorHeader = "Update a version for a group";
        } else {
          this.isEditorVisible = true;
          this.versionId = -1; //shouldn't edit
          this.VersionEditorHeader = "Creare new version";
        }
      },
      editChange(id) {
        this.isEditorVisible = true;
        this.versionId = id;
        this.VersionEditorHeader = "Edit version";
      },
      deleteVersionModal(id) {
        this.isDeleteModalVisible = true;
        this.versionId = id;
      },
      deleteVersion() {
        this.HTTP.delete(`productversions/` + this.versionId)
          .then(response => {
            this.closeChangeDeleteWindow();
          })
          .catch(e => {
            console.log(e);
          });
      },
      closeVersionEditor() {
        this.isEditorVisible = false;
        this.getVersions(); //should be optimized!
      },
      closeGroupVersionEditor() {
        this.isUpdatingGroup = false;
        this.getVersions(); //should be optimized!
      },
      closeChangeDeleteWindow() {
        this.isDeleteModalVisible = false;
        this.getVersions(); //should be optimized!
      },

      //pagination

      urlBuilder(page) {
        return { query: { ...this.$route.query, page } }; // Changing page in location query
      },

      searchHandler(searchingText) {
        this.searchingText = searchingText;
      },

      clearSearch() {
        this.searchingText = "";
        this.page.pageNumber = 1;
      },

      pushUrl() {
        this.$router.push({
          path: "Versions",
          query: {
            productId: this.productId,
            groupId: this.groupId,
            page: this.page.pageNumber,
            search: this.searchingText
          }
        });
      }
    },
    computed: {
      filterMsg: function () {
        if (this.page.totalItems > 0)
          return "<strong>" + this.page.totalItems + "</strong> versions";
        else return "";
      }
    },
    created() {
      if (this.cardsCount) {
        this.page.pageSize = this.cardsCount;
      }
      this.loading = true;
      this.HTTP.load(); //.then(() => {
      this.getGroups()
        .then(response => {
          this.groups = response.data.entities;
          this.groupId = !isNaN(this.selectedGroupId) && viewingGroups
            ? this.selectedGroupId : -1;
          //this.getVersions();
          //this.loading = false;
        })
        .catch(e => {
          console.log(e);
        });
      this.getProducts()
        .then(response => {
          this.products = response.data.entities;
          this.productId = !isNaN(this.selectedProductId) || this.selectedProductId != -1
            ? this.selectedProductId
            : response.data.entities[0].id;
          //this.pushUrl();
          this.getVersions();
          this.loading = false;
        })
        .catch(e => {
          console.log(e);
        });
    },

    watch: {
      $route(to, from) {
        if (to.query.page != null && to.query.page != undefined) {
          this.page.pageNumber = parseInt(to.query.page);
          this.productId = parseInt(to.query.productId);
          this.groupId = parseInt(to.query.groupId);
          this.searchingText = to.query.search;
        } else {
          //this.pushUrl();
        }

        this.getVersions();
      },
      productId: function (val) {
        if (!isNaN(val)) this.selectedProductId = val;
        this.pushUrl();
      },
      groupId: function (val) {
        if (!isNaN(val)) this.selectedGroupId = val;
        this.pushUrl();
      },
      searchingText: function (val) {
        this.pushUrl();
      },
      page: function (val) {
        this.pushUrl();
      }
    }
  };
</script>

<style>
  #app {
    /* font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px; */
    display: flex;
    min-height: 100vh;
    flex-direction: column;
    margin: 0;
  }

  * {
    box-sizing: border-box;
  }

  body {
    display: flex;
    min-height: 100vh;
    flex-direction: column;
    margin: 0;
  }

  #main {
    display: flex;
    flex: 1;
  }

    #main > aside {
      flex: 0 0 10vw;
      /* background: beige; */
    }

  /* #main>nav {
      order: -1;
  } */

  .footer {
    /* background: yellowgreen; */
    height: 10vh;
  }

  /* footer, */
  /* .article,
  .nav,
  .aside {
    padding: 1em;
  } */

  nav.navbar {
    padding: 0em;
  }

  .card {
    /* margin: 1em; */
  }
</style>



// WEBPACK FOOTER //
// src/components/views/Versions.Vue